import React, { useCallback, useEffect, useMemo, useState } from 'react';
import './AdminFaqs.scss'
import { apiFaq } from '../../../axios';
import { MdDelete } from "react-icons/md";
import { FaPen } from "react-icons/fa";
import { alertForConfirmRequest } from '../../../utils/helpers';
import { useModal } from '../../../components/Modals';
import Table from '../../../components/Table';
import { adminFaqPost, adminFaqUpdate, adminFaqDelete } from '../../../axios/admin/manageFaq';
import { PAGE_LIMIT_ADMIN } from '../../../data/globalConstants';


const AdminFaq = () => {


    const dispatchModal = useModal();
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);

    const getData = useCallback(async (paramsObj) => {
        try {
            setLoading(true);
            const result = await apiFaq.getFaques(paramsObj);
            const faqCount = paramsObj?.page === 1 ? await apiFaq.getFaqCount(paramsObj) : count;
            setCount(faqCount);
            setData(result);
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }, [count]);

    const createHandler = useCallback(async (fieldsObj = {}) => {
        await adminFaqPost(fieldsObj);
        getData({
            page: page,
            limit: PAGE_LIMIT_ADMIN,
            search: search,
        });
    }, [getData, search, page]);

    const deleteHandler = useCallback(async (id) => {
        await adminFaqDelete({
            id: id
        });
        getData({
            page: page,
            limit: PAGE_LIMIT_ADMIN,
            search: search
        });
    }, [getData, search, page]);

    const updateHandler = useCallback(async (fieldsObj) => {
        await adminFaqUpdate(fieldsObj);
        getData({
            page: page,
            limit: PAGE_LIMIT_ADMIN,
            search: search
        });
    }, [getData, search, page]);

    const createOrUpdate = useCallback((obj = {}) => {
        dispatchModal('createEditFaq', { obj: obj, handleSuccess: (result) => obj?.id ? updateHandler(result) : createHandler(result) })
    }, [dispatchModal, createHandler, updateHandler]);

    useEffect(() => {
        getData({
            page: page,
            limit: PAGE_LIMIT_ADMIN,
            search: search
        });
    }, [getData, search, page]);

    const columns = useMemo(() => [
        {
            key: "question",
            children: "Питання"
        },
        {
            key: "answer",
            children: "Відповідь"
        },
        {
            key: "controls",
            style: {
                width: 145
            },
            children: "Керування"
        }
    ], []);

    const dataRows = useMemo(() => data.map(itm => ({
        key: itm?._id,
        className: 'admin_table_row',
        rowData: [
            {
                children: itm?.question
            },
            {
                children: itm?.answer?.length > 65 ? itm?.answer?.substring(0, 65) + '...' : itm?.answer
            },
            {
                className: 'admin_controll_btn',
                children: <>
                    <button
                        className='admin_rewrite_btn'
                        onClick={() => createOrUpdate({
                            id: itm?._id,
                            question: itm?.question,
                            answer: itm?.answer
                        })}
                    >
                        <FaPen />
                    </button>
                    <button
                        className='admin_delete_btn'
                        onClick={() => alertForConfirmRequest(deleteHandler, itm?._id)}
                    >
                        <MdDelete />
                    </button>
                </>
            }
        ]
    })), [data, createOrUpdate, deleteHandler]);

    const emptyText = useMemo(() => {
        return search === '' ? <div className='admin_empty_table'>
            Список питань порожній
            <br />
            <button className='admin_create_element' onClick={() => createOrUpdate()}>Створити</button>
        </div> : `За пошуком "${search}" нікого не знайдено`
    }, [search, createOrUpdate]);

    return (
        <section className='admin_administration_wrapper'>
            <div className='admin_page_content'>
                <h2 className='admin_page_title'>
                    Питання / Відповідь
                </h2>
                <div className='admin_filters_block'>
                    <input className='admin_search_input' type='text' placeholder='Пошук' onChange={e => setSearch(e.target.value)} />
                    <button className='admin_create_element' onClick={() => createOrUpdate()}>Створити</button>
                </div>

                <div className='admin_table_block'>
                    <Table
                        columns={columns}
                        data={dataRows}
                        loading={loading}
                        emptyText={emptyText}
                        pagination={{
                            count: count,
                            page: page,
                            onChange: (number) => setPage(number),
                            pageLimit: PAGE_LIMIT_ADMIN
                        }}
                    />
                </div>
            </div>
        </section>
    );
};

export default AdminFaq;